// Header stack above every mobile drop-down/drawer: the main row plus the
// search-bar row below it. Hardcoded rather than measured at runtime, since
// the header's on-screen height is otherwise static — verified against the
// rendered header's offsetHeight. Shared by the hamburger drawer
// (mobile-navigation.tsx) and the search panel (mobile-search.tsx), which
// both open flush beneath the same header.
export const MOBILE_HEADER_HEIGHT = 117;
